import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { ApiUrlConstant } from "./../../../../constants/api-url.constant";
import { Observable } from "rxjs";

@Injectable()
export class TransportationWarehosueUtlizationService {
  baseUrl = environment.gateWayHost;
  editItem: any;

  constructor(
    public generic: GenericHttpService,
    private apiUrl: ApiUrlConstant
  ) { }

  getData(options): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.baseUrl}${options.url}`,
      query: options.params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processTransferEndToEndSlaTrend)
    );
  }
  processTransferEndToEndSlaTrend(data: any) {
    const tat1 = [];
    const tat2 = [];
    const tat3 = [];
    const greaterThan3 = [];
    if (data.data.length === 0) return null;
    let dataKeys = [];
    let allKey = "All";
    let parentIndex = -1;
    let __v2Data = data.data[0].TransportationTATBreakupV2;
    let __v2DataWithoutDataKey = { ...__v2Data };
    delete __v2DataWithoutDataKey["data"];

    if (Object.keys(__v2DataWithoutDataKey).length > 1) {
      dataKeys = Object.keys(__v2Data);
    } else if (Object.keys(__v2DataWithoutDataKey).length === 1) {
      allKey = Object.keys(__v2Data)[0];
      __v2Data = __v2Data[Object.keys(__v2Data)[0]];
      dataKeys = Object.keys(__v2Data);
      __v2DataWithoutDataKey = { ...__v2Data };
      delete __v2DataWithoutDataKey["data"];
      if (Object.keys(__v2DataWithoutDataKey).length > 1) {
        dataKeys = Object.keys(__v2Data);
      } else if (Object.keys(__v2DataWithoutDataKey).length === 1) {
        allKey = Object.keys(__v2Data)[0];
        __v2Data = __v2Data[Object.keys(__v2Data)[0]];
        dataKeys = Object.keys(__v2Data);
      }
    }

    const columns = dataKeys.map((_dataName, index) => {
      let __data = {};
      if (_dataName === "data") {
        __data = __v2Data[_dataName];
      } else {
        __data = __v2Data[_dataName]["data"];
      }
      tat1.push(
        Number(
          (
            (__data["tat_1"] /
              (__data["tat_1"] +
                __data["tat_2"] +
                __data["tat_3"] +
                __data["tat_greater_3"])) *
            100
          ).toFixed(2)
        )
      );
      tat2.push(
        Number(
          (
            (__data["tat_2"] /
              (__data["tat_1"] +
                __data["tat_2"] +
                __data["tat_3"] +
                __data["tat_greater_3"])) *
            100
          ).toFixed(2)
        )
      );
      tat3.push(
        Number(
          (
            (__data["tat_3"] /
              (__data["tat_1"] +
                __data["tat_2"] +
                __data["tat_3"] +
                __data["tat_greater_3"])) *
            100
          ).toFixed(2)
        )
      );
      greaterThan3.push(
        Number(
          (
            (__data["tat_greater_3"] /
              (__data["tat_1"] +
                __data["tat_2"] +
                __data["tat_3"] +
                __data["tat_greater_3"])) *
            100
          ).toFixed(2)
        )
      );

      if (_dataName === "data") {
        parentIndex = index;
      }

      return _dataName === "data" ? allKey : _dataName;
    });

    tat1.splice(0, 0, tat1.splice(parentIndex, 1)[0]);
    tat2.splice(0, 0, tat2.splice(parentIndex, 1)[0]);
    tat3.splice(0, 0, tat3.splice(parentIndex, 1)[0]);
    greaterThan3.splice(0, 0, greaterThan3.splice(parentIndex, 1)[0]);

    columns.splice(0, 0, columns.splice(parentIndex, 1)[0]);

    const Alldata = [];
    const OneData = [];
    columns.forEach(ele => {
      if (ele === "All") {
        OneData.push(ele);
      } else {
        Alldata.push(ele);
      }
    });
    const categories = OneData.concat(Alldata);
    return [tat1, tat2, tat3, greaterThan3, categories];
  }

  createChart(chartData, Options) {
    const chart = JSON.parse(JSON.stringify(HSET.chartData));



    chart.xAxis.categories = chartData[chartData.length - 1];

    for (let i = 0; i < chartData.length - 1; i++) {

      chart.series[i] = chartData[i];
    }
    // chart.series[0].data = chartData.tat1;
    // chart.series[1].data = chartData.tat2;
    // chart.series[2].data = chartData.tat3;
    // chart.series[3].data = chartData.greaterThan3;

    

    return chart;
  }
}
